module.exports = __webpack_public_path__ + "img/incidence.2b4f276c.svg";